<template>
    <div class="flex flex-wrap gap-x-2 items-center w-full">
        <div>
            Página
        </div>
        <div class="my-3">
            <input
                @keyup.enter="changePage(page)"
                :class="{'w-8': page <= 9, 'w-12': page >= 10 && page <= 999, 'w-16': page >= 1000 }"
                class="w-8 text-center border rounded px-2 leading-loose"
                type="text"
                v-model="page"
            >
        </div>
        <div>de {{ this.lastPage }}</div>
        <div class="flex">
            <div>
                <inertia-link
                    v-if="prevPageUrl"
                    class="px-3 py-1 rounded-l bg-green-600 hover:bg-green-700 transition-colors duration-300 text-center text-white"
                    :class="{'cursor-not-allowed' : !prevPageUrl}"
                    :href="prevPageUrl"
                >
                    <i class="fa fa-chevron-left"></i>
                </inertia-link>
            </div>
            <div>
                <inertia-link
                    v-if="nextPageUrl"
                    class="px-3 py-1 rounded-r bg-green-600 hover:bg-green-700 transition-colors duration-300 text-center text-white"
                    :class="{'cursor-not-allowed' : !nextPageUrl}"
                    :href="nextPageUrl"
                >
                    <i class="fa fa-chevron-right"></i>
                </inertia-link>
            </div>
        </div>
    </div>
</template>

<script>
const queryString = require('query-string');

export default {
    props: ['nextPageUrl', 'prevPageUrl', 'lastPage', 'currentPage', 'path'],

    data() {
        return {
            page: this.currentPage,
        }
    },

    methods: {
        _() {
            return _;
        },

        changePage(page) {
            this.$inertia.visit(`${this.path}?${this.getQueryString(page)}`, {
                method: 'get',
            })
        },

        getQueryString(page = 1) {
            var params = {...this.$page.request, ...{page: page}};
            return queryString.stringify(params, {arrayFormat: 'bracket'});
        },
    },
}
</script>
